import React from 'react';
import PropTypes from 'prop-types';

import { genKey } from '../../utils/addKey';

import styles from './DefinitionList.css';

/**
 * DefinitionList Typography Component
 */
const DefinitionList = ({ data, theme }) => (
    <dl className={theme}>
        {data.map(([key, value]) => (
            <React.Fragment key={`frag-${key}-${genKey()}`}>
                <div className="term-wrapper">
                    <dt key={`dt-${key}-${genKey()}`}>{key}: </dt>
                    <dd key={`dd-${key}-${genKey()}`}>{value}</dd>
                </div>
            </React.Fragment>
        ))}
        <style jsx>{styles}</style>
    </dl>
);

DefinitionList.defaultProps = {
    theme: 'vertical'
};

DefinitionList.propTypes = {
    data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)).isRequired,
    theme: PropTypes.string
};

export default DefinitionList;
